import {TableTagDef} from '../../../sdk/src/components/generic-table/table-col-def';
import {TreeTagDef} from '../../../sdk/src/components/generic-tree/tree-col-def';

/**
 * Task utilities
 */
export abstract class TaskExecutionUtils {
    public static readonly jobLogEntryLevelTags: (TableTagDef | TreeTagDef)[] = [
        {
            style: {background: '#DDDDDD', color: 'black !important'},
            label: 'Debug',
            value: 10,
            icon: 'pi pi-circle-fill',
            iconStyle: {color: '#333333', fontSize: '70%', verticalAlign: 'middle'}
        },
        {
            style: {background: '#B5E8F7', color: 'black !important'},
            label: 'Info',
            value: 20,
            icon: 'pi pi-circle-fill',
            iconStyle: {color: '#4BB4E6', fontSize: '70%', verticalAlign: 'middle'}
        },
        {
            style: {background: '#fff8da', color: 'black !important'},
            label: 'Warning',
            value: 30,
            icon: 'pi pi-circle-fill',
            iconStyle: {color: '#ffd200', fontSize: '70%', verticalAlign: 'middle'}
        },
        {
            style: {background: '#ffe8d4', color: 'black !important'},
            label: 'Error',
            value: 40,
            icon: 'pi pi-circle-fill',
            iconStyle: {color: '#ff7900', fontSize: '70%', verticalAlign: 'middle'}
        },
        {
            style: {background: '#FDE5E6', color: 'black !important'},
            label: 'Critical',
            value: 50,
            icon: 'pi pi-circle-fill',
            iconStyle: {color: '#cd3c14', fontSize: '70%', verticalAlign: 'middle'}
        }
    ];
}
